import styled from "@emotion/styled";

export const GridBreak = styled.div`
    width: 100%
`;